import {
  Building,
  CreditCard,
  FileInput,
  FileOutput,
  LayoutDashboard,
  PieChart,
  Wallet,
} from 'lucide-react';

import { FinancialAccountListView } from './_components/accounts/_FinancialAccountListView';
import { BalancesListView } from './_components/balances/_BalancesListView';
import { BillDetailView } from './_components/bills/_BillDetailView';
import { BillsListView } from './_components/bills/_BillsListView';
import { InvoiceDetailView } from './_components/invoices/_InvoiceDetailView';
import { InvoicesListView } from './_components/invoices/_InvoicesListView';
import { FinanceOverview } from './_components/overview/_FinanceOverview';
import { PaymentDetailView } from './_components/payments/_PaymentDetailView';
import { PaymentsListView } from './_components/payments/_PaymentsListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/finance';

export const financeRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.finance.root,
    icon: Wallet,
  },
  overview: {
    path: `${basePath}/overview`,
    label: (t) => t.menu.finance.overview,
    icon: LayoutDashboard,
    component: FinanceOverview,
  },
  accounts: {
    path: `${basePath}/financial-accounts`,
    label: (t) => t.menu.finance.financialAccounts,
    icon: Building,
    component: FinancialAccountListView,
    requiredPermission: 'financialAccountRead',
  },
  balances: {
    path: `${basePath}/balances`,
    label: (t) => t.menu.finance.balances.root,
    icon: PieChart,
    component: BalancesListView,
  },
  bills: {
    path: `${basePath}/bills`,
    label: (t) => t.menu.finance.bills.root,
    icon: FileOutput,
    component: BillsListView,
    requiredPermission: 'billRead',
  },
  billDetail: {
    path: `${basePath}/bills/:id`,
    component: BillDetailView,
  },
  invoices: {
    path: `${basePath}/invoices`,
    label: (t) => t.menu.finance.invoices.root,
    icon: FileInput,
    component: InvoicesListView,
    requiredPermission: 'invoiceRead',
  },
  invoiceDetail: {
    path: `${basePath}/invoices/:id`,
    component: InvoiceDetailView,
  },
  payments: {
    path: `${basePath}/payments`,
    label: (t) => t.menu.finance.payments.root,
    icon: CreditCard,
    component: PaymentsListView,
    requiredPermission: 'paymentRead',
  },
  paymentDetail: {
    path: `${basePath}/payments/:id`,
    component: PaymentDetailView,
  },
});

const financeNav = createModuleNav(($) =>
  $(financeRoutes.root, [
    $(financeRoutes.overview),
    $(financeRoutes.accounts),
    $(financeRoutes.balances),
    $(financeRoutes.bills),
    $(financeRoutes.billDetail),
    $(financeRoutes.invoices),
    $(financeRoutes.invoiceDetail),
    $(financeRoutes.payments),
    $(financeRoutes.paymentDetail),
  ]),
);

export const financeModule = createAppModule({
  routes: financeRoutes,
  nav: financeNav,
});
